import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'

export const OPERACOES_TYPE = {
  ENTRADA: 'Entrada',
  SAIDA: 'Saída',
  TRANSFERENCIA: 'Transferência',
}

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_MOTIVOS: 'Carregando os motivos',
  DELETE: 'Apagando operação',
}

const INITIAL_STATE = {
  motivos: [],
  showModal: false,
  selectedOperacao: null,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useCadastroMotivoBloqueioPosicaoEstoque() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      async getMotivosBloqueio(tpId) {
        EstoqueHttp.getMotivosBloqueioPosicaoEstoque(tpId)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              motivos: res,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      async deleteMotivoBloqueio(tpId, selectedMotivo) {
        await EstoqueHttp.deleteMotivosBloqueioPosicaoEstoque(tpId, selectedMotivo)
          .then(res =>
            setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_MOTIVOS })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      //Events
      onInit(selectedTp) {
        if (selectedTp)
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_MOTIVOS }))
        else
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um Operador Logístico' }))
      },

      toggleModal(visible, selectedMotivo) {
        setState(prevState => ({ ...prevState, showModal: visible, selectedMotivo }))
      },

      onModalSave(motivo) {
        setState(prevState => {
          const index = prevState.motivos.findIndex(m => m.id === motivo.id)
          if (index !== -1) prevState.motivos[index] = motivo
          else prevState.motivos.push(motivo)
          return {
            ...prevState,
            showModal: false,
            selectedOperacao: null,
            loadingMessage: LOAD_MESSAGE.GET_MOTIVOS,
          }
        })
      },

      onMenuItemClicked(item, operacao) {
        switch (item) {
          case '1. Apagar':
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.DELETE,
              selectedOperacao: operacao,
            }))
            break
          default:
            break
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
